<template>
  <v-container fluid fill-height grid-list-md pt-0 style="padding-bottom: 50px">
    <v-layout column>
    <v-toolbar
      color="#eee"
      class="elevation-0 secondary--text"
      style="background: transparent"
      >
        <v-select
          v-model="selectedReport"
          :items="reports"
          label="Selecione um relatório para visualizar"
          item-text="nome"
          item-value="path"
          solo
        ></v-select>
    </v-toolbar>
    <router-view></router-view>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data () {
    return {
      reports: [
        {
          nome: 'Relatório de compras',
          path: '/relatorio/compras'
        },
        {
          nome: 'Relatório de vouchers',
          path: '/relatorio/vouchers'
        },
        {
          nome: 'Relatório de Dividas',
          path: '/relatorio/dividas-apetrus'
        },
        {
          nome: 'Relatório de leilões',
          path: '/relatorio/leiloes'
        },
        {
          nome: 'Relatório de Assinaturas',
          path: '/relatorio/assinaturas'
        },
        {
          nome: 'Relatório de Pedidos',
          path: '/relatorio/pedidos'
        }
      ],
      selectedReport: null
    }
  },
  watch: {
    selectedReport (val) {
      if (val !== null && val !== undefined) {
        this.$router.push(val)
      }
    },
    '$route' (val) {
      if (val.path === '/relatorio') {
        this.selectedReport = this.reports[0].path
        this.$router.push(this.reports[0].path)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.selectedReport) {
        this.selectedReport = this.reports[0].path
      }
    })
  }
}
</script>
